import { render } from "./ImageWide.vue?vue&type=template&id=de389f0c"
import script from "./ImageWide.vue?vue&type=script&lang=js"
export * from "./ImageWide.vue?vue&type=script&lang=js"

import "./ImageWide.vue?vue&type=style&index=0&id=de389f0c&lang=scss"
script.render = render

export default script